module.exports = __webpack_public_path__ + "static/Hero-Banner-Manufacturing-3-69fe1b9c5c6c29b46d3e9a1df4f28132.jpg";